import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpApiService} from "../../../../services/http-api.service";
import {EndpointsService} from "../../../../services/endpoints.service";
import {UserService} from "../../../../services/user.service";
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-update-user',
  templateUrl: './update-user.component.html'
})
export class UpdateUserComponent implements OnInit {
  @Input('haserror') hasError = false;
  @Input('isupdated') isUpdated = false;
  errorMessage: any;
  selectedPage = 'myAccount';
  @Input('fileData')fileData: any = {};
  isUploading: boolean;
  @Input('user')user;
  @Input('isLoggedInUser')isLoggedInUser = false;
  @Output('userResponse') userResponse = new EventEmitter();

  constructor(private Api: HttpApiService,
              private userService: UserService,
              private endpoints: EndpointsService,
              private route: ActivatedRoute) {
    this.userService.handleMyAccountEvent()
      .subscribe(res => {
        this.updateSelectedPage();
      });
  }

  ngOnInit() {
    if (!this.user) {
      this.userService.getCurrentUser(true)
        .then((user: any) => {
          this.user = user;
          if (this.user.buyerCompanyName) {
            this.user.companyName = this.user.buyerCompanyName;
          }
          this.isLoggedInUser = true;
          if (user.pictureUrl) {
            this.fileData.profileImage = user.pictureUrl;
          }
          this.user.previousUserName = this.user.username;
        });
    } else {
      this.user.previousUserName = this.user.username;
      this.fileData.profileImage = this.user.pictureUrl;
    }
  }

  updateSelectedPage() {
    if (this.route.snapshot.queryParams.activity) {
      this.selectedPage = this.route.snapshot.queryParams.activity;
    }
  }

  updateUser(user) {
    this.hasError = false;
    this.isUpdated = false;
    this.isUploading = true;
    user.pictureData = this.fileData;
    this.Api.put(this.endpoints.getUserUrl() + '/' + user.id, user, true)
      .subscribe(response => {
          this.isUpdated = true;
          this.user = response;
          if (this.user.buyerCompanyName) {
            this.user.companyName = this.user.buyerCompanyName;
          }
          this.user.previousUserName = this.user.username;
          this.fileData.profileImage = this.user.pictureUrl;
          this.fileData.fileName = '';
          this.isUploading = false;
          if (!this.isLoggedInUser) {
            this.userResponse.emit(this.user);
          } else {
            this.userService.setCurrentUser(response);
          }
        },
        error => {
          this.isUploading = false;
          this.hasError = true;
          this.errorMessage = error;
        });
    return false;
  }

  isSuperAdmin() {
    return this.userService.isSuperAdmin();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/user/update-user/update-user.component.ts